<template>
  <div class="basic">
    <pro-layout
      :menus="menus"
      :collapsed="collapsed"
      :mediaQuery="query"
      :isMobile="isMobile"
      :handleMediaQuery="handleMediaQuery"
      :handleCollapse="handleCollapse"
      :i18nRender="i18nRender"
      :logo="switchIcon"
      v-bind="settings"
    >
      <template v-slot:collapsedButton>
        <span class="custom-collapse-icon">
          <a-icon :type="collapsed ? 'menu-unfold' : 'menu-fold'" />
        </span>
      </template>
      <!-- openKeys={true} -->
      <tags-view v-if="needTagsView" :collapsed="collapsed" :is-mobile="isMobile" />
      <div v-if="needTagsView" class="tags-view-spacer"></div>
      <!-- Ads begin
      广告代码 真实项目中请移除
      production remove this Ads
   

      <ads v-if="isProPreviewSite && !collapsed" />

     Ads end -->

      <!-- 1.0.0+ 版本 pro-layout 提供 API，
          我们推荐使用这种方式进行 LOGO 和 title 自定义
      -->
      <template v-slot:menuHeaderRender>
        <div class="sider-brand">
          <span class="sider-brand-logo">
            <img src="@/assets/wLogo.png" alt="logo" />
          </span>
          <span class="sider-brand-copy">
            <strong>{{ title }}</strong>
            <small>RETAIL WORKSPACE</small>
          </span>
        </div>
      </template>
      <template v-slot:logo>
        <span class="collapsed-brand-logo">
          <img src="@/assets/wLogo.png" alt="logo" />
        </span>
      </template>
      <!-- 1.0.0+ 版本 pro-layout 提供 API,
          增加 Header 左侧内容区自定义
    -->
      <template v-slot:headerContentRender>
        <div v-if="isMobile">
          <div style="padding-left: 0; color: #ffffff; display: flex; align-items: center; height: 45px">
            <img src="/logo.png" style="margin-left: 20px" height="40" />
            <h1 style="height: 45px; line-height: 45px; margin-bottom: 0; color: #fff">{{ title }}</h1>
          </div>
          <!-- <a-tooltip title="刷新页面">
          <a-icon type="reload" style="font-size: 18px;cursor: pointer;" @click="() => { $message.info('只是一个DEMO') }" />
        </a-tooltip> -->
          <!-- <img src="/logo.png" />
        <h1>{{ title }}</h1> -->
        </div>
      </template>
      <!-- <template v-slot:breadcrumbRender>
      <page-header-wrapper :title="false"></page-header-wrapper>
    </template> -->
      <template v-slot:rightContentRender>
        <right-content :top-menu="settings.layout === 'topmenu'" :is-mobile="isMobile" :theme="settings.theme" />
      </template>

      <keep-alive v-if="$route.meta.keepAlive">
        <router-view :key="$route.fullPath" />
      </keep-alive>
      <router-view :key="$route.fullPath" v-if="!$route.meta.keepAlive" />
    </pro-layout>
  </div>
</template>

<script>
import { updateTheme } from '@ant-design-vue/pro-layout'
import TagsView from './TagsView/index.vue'
import switchIcon from '@/assets/switchIcon.png'
import { i18nRender } from '@/locales'
import { mapState } from 'vuex'
import { CONTENT_WIDTH_TYPE, SIDEBAR_TYPE, TOGGLE_MOBILE_TYPE } from '@/store/mutation-types'
import { getTenantUsingGET } from '@/api/api/quanxianrenzhengguanli.ts'
import defaultSettings from '@/config/defaultSettings'
import RightContent from '@/components/GlobalHeader/RightContent'
import Ads from '@/components/Other/CarbonAds'
import { getTenantIdByDomain } from '@/api/login'

export default {
  name: 'BasicLayout',
  components: {
    RightContent,
    Ads,
    TagsView,
  },
  data() {
    return {
      switchIcon,
      // preview.pro.antdv.com only use.
      isProPreviewSite: process.env.VUE_APP_PREVIEW === 'true' && process.env.NODE_ENV !== 'development',
      // end
      // base
      menus: [],
      // 侧栏收起状态

      collapsed: false,
      title: defaultSettings.title,
      settings: {
        // 布局类型
        layout: defaultSettings.layout, // 'sidemenu', 'topmenu'
        // CONTENT_WIDTH_TYPE
        contentWidth: defaultSettings.layout === 'sidemenu' ? CONTENT_WIDTH_TYPE.Fluid : defaultSettings.contentWidth,
        // 主题 'dark' | 'light'
        theme: defaultSettings.navTheme,
        // 主色调
        primaryColor: defaultSettings.primaryColor,
        fixedHeader: defaultSettings.fixedHeader,
        fixSiderbar: defaultSettings.fixSiderbar,
        colorWeak: defaultSettings.colorWeak,

        hideHintAlert: false,
        hideCopyButton: false,
        // collapse: false,
      },
      // 媒体查询
      query: {},

      // 是否手机模式
      isMobile: false,
      tenantId: undefined,
    }
  },
  computed: {
    ...mapState({
      // 动态主路由
      mainMenu: (state) => state.permission.addRouters,
      needTagsView: (state) => state.settings.tagsView,
    }),
    cachedViews() {
      return this.$store.state.tagsView.cachedViews
    },
  },

  created() {
    const routes = this.mainMenu.find((item) => item.path === '/')
    // if (window.location.host.split('.')?.[0]) {
    //   const octalRegex = /^(0o)?[0-7]+$/i
    //   const tenantIdStr = window.location.host.split('.')?.[0]
    //   const tenantId = octalRegex.test(tenantIdStr) ? tenantIdStr : 1
    //   getTenantUsingGET({ id: tenantId })
    //     .then((res) => {
    //       if (res.code == 200) {
    //         this.title = `比目鱼 - ${res.data.tenantName}`
    //       }
    //     })
    //     .catch((error) => {
    //
    //     })
    // }
    // getTenantIdByDomain(window.location.host)
    //   .then((res) => {

    //     this.info = res.data
    //   })
    //   .catch((error) => {})
    this.menus = (routes && routes.children) || []
    // 处理侧栏收起状态
    this.$watch('collapsed', () => {
      this.$store.commit(SIDEBAR_TYPE, this.collapsed)
    })
    this.$watch('isMobile', () => {
      this.collapsed = true
      this.$store.commit(TOGGLE_MOBILE_TYPE, this.collapsed, this.isMobile)
    })
  },
  watch: {
    $route(to, from) {
      if (this.isMobile) {
        this.collapsed = true
      }
    },
  },
  mounted() {
    const userAgent = navigator.userAgent
    if (userAgent.indexOf('Edge') > -1) {
      this.$nextTick(() => {
        this.collapsed = !this.collapsed
        setTimeout(() => {
          this.collapsed = !this.collapsed
        }, 16)
      })
    }

    // first update color
    // TIPS: THEME COLOR HANDLER!! PLEASE CHECK THAT!!
    if (process.env.NODE_ENV !== 'production' || process.env.VUE_APP_PREVIEW === 'true') {
      updateTheme(this.settings.primaryColor)
    }
  },
  methods: {
    i18nRender,
    handleMediaQuery(val) {
      this.query = val
      if (this.isMobile && !val['screen-xs']) {
        this.isMobile = false
        return
      }
      if (!this.isMobile && val['screen-xs']) {
        this.isMobile = true
        this.collapsed = false
        this.settings.contentWidth = CONTENT_WIDTH_TYPE.Fluid
        // this.settings.fixSiderbar = false
      }
    },
    handleCollapse(val) {
      this.collapsed = val
    },
  },
}
</script>

<style lang="less">
@import './BasicLayout.less';
.ant-pro-global-header {
  min-width: 375px !important;
}
.ant-pro-global-header {
  height: 56px;
  padding: 0 18px 0 0;
  color: #344054;
  line-height: 56px;
  background: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid #edf0f4;
  box-shadow: 0 2px 12px rgba(24, 34, 48, 0.045);
  backdrop-filter: blur(12px);
}
.ant-layout-header {
  height: 56px;
  line-height: 56px;
}
.ant-pro-global-header-trigger {
  height: 56px;
  line-height: 56px;
  transition: background 0.2s ease;

  &:hover {
    background: #f6f8fb;
  }
}
.ant-pro-global-header-content {
  height: 56px;
}
.ant-pro-page-header-wrap-page-header-warp {
  display: none;
}
.ant-pro-page-header-wrap-children-content {
  margin: 18px 24px 28px;
}
.tags-view-spacer {
  height: 44px;
  flex: 0 0 44px;
}
@media screen and (max-width: 750px) {
  .ant-layout-content {
    margin-top: 0;
  }
  /* 在此处编写对应的样式 */
  .ant-pro-global-header-logo {
    display: none;
    height: 45px;
  }
  .ant-pro-global-header-index-right {
    margin-right: 0;
  }
  .ant-pro-global-header-index-right {
    float: none;
  }
}
</style>
